module.exports = __webpack_public_path__ + "img/金属材料学1_6.80194c2b.png";